<template>
  <div class="geofences">
    <div class="header">GEOFENCES</div>
    <div class="geofence-container">
      <div class="geofence list">
        <geofence-list></geofence-list>
      </div>
      <div class="toggle-mobile" @click="showMapMobile = !showMapMobile">
        <span v-if="!showMapMobile">Show Map <i class="fa fa-chevron-up"></i></span>
        <span v-else>Hide Map <i class="fa fa-chevron-down"></i></span>  
      </div>
      <div :class="['geofence map', showMapMobile ? 'showMapBox' : '']">
        <!-- <geofence-map v-if="$route.name === 'Geofence'"></geofence-map> -->
        <geofence-map2></geofence-map2>
      </div>
    </div>

    <geofence-create></geofence-create>
    <geofence-priority></geofence-priority>
    <geofence-promo-prices></geofence-promo-prices>
    <modal></modal>
  </div>
</template>

<script>
import GeofenceList from './GeofenceList'
// import GeofenceMap from './GeofenceMap'
import GeofenceMap2 from './GeofenceMap2'
import GeofenceCreate from './GeofenceCreate'
import GeofencePriority from './GeofencePriority'
import GeofencePromoPrices from './GeofencePromoPrices'
import services from '@/modules/api/services'
import Modal from './Modal'

export default {
  name: 'geofences',
  components: { GeofenceList, GeofenceMap2, GeofenceCreate, GeofencePriority, GeofencePromoPrices, Modal },
  data() {
    return {
      showMapMobile: false
    }
  },
  methods: {
    getBrands () {
      let self = this
      if (!self.$store.state.brands.list.length) {
        // self.serviceLoading = true
        self.$sdk.get('/brand', {}, res => {
          if (res.error) { return }

          if (res.length) {
            self.$store.commit('brands/setList', res)
            if (!self.$store.state.services.list.length) {
              self.getServices()
              return
            }
            // self.serviceLoading = false
          }
        })
      } else {
        self.getServices()
      }
    },
    getServices () {
      let self = this
      // self.serviceLoading = true
      services.getAllService(self, r => {
        // self.serviceLoading = false
      })
    }
  },
  mounted () {
    this.getBrands()
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  z-index: 2;
}

.geofences { position: relative; }
.geofence-container {
  position: fixed;
  top: 51px;
  left: 0;
  width: 100%;
  height: 100%;
}

$list-width: 60%;

.geofence {
  position: absolute;
  top: 0;
  height: 100%;

  &.list {
    left: 0;
    overflow-y: auto;
    width: $list-width;
    z-index: 1;
    box-shadow: 2px 4px 8px rgba(0,0,0,0.3);
  }

  &.map {
    left: $list-width;
    width: calc(100% - #{$list-width});
    z-index: 0;
  }
}

.toggle-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }
  .geofence {
    &.list {
      width: 100%;
    }
    &.map {
      width: 100%;
      z-index: 5;
      left: 0;
      top: 100%;
      transition: all 0.3s ease;
  
      &.showMapBox {
        top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/index.vue